<i18n lang='yml' src='../i18n/StatusForm.yml'></i18n>
<template>
  <fieldset class="border-bottom">
    <div class="col-lg-9">
      <div class="form-group">
        <label for="name_en">{{ $t('name_en.label') }}<span class="text-danger">*</span></label>
        <input :class="formClasses('name_en')" id="name_en" :value="getName('en')" :name="`${object_name}[name_en]`" type="text">
      </div>
      <div class="form-group">
        <label for="name_fr">{{ $t('name_fr.label') }}<span class="text-danger">*</span></label> 
        <input :class="formClasses('name_fr')" id="name_fr" :value="getName('fr')" :name="`${object_name}[name_fr]`" type="text">
      </div>
      <div v-if="approval === 'true'" class="form-group select-group fr">
        <div class="form-group select-group fr">
          <label for="approved">{{ $t('means_approved.label', {type: $t(object_name)}) }}
            <input :name="`${object_name}[approved]`" type="hidden" :value="false" />
            <input id="approved" :name="`${object_name}[approved]`" :checked="true" @change="separateStates" v-model="parsedObject.approved" type="checkbox">
          </label>
        </div>
        <div class="form-group select-group">
          <label for="request_approval">{{ $t('means_request_approval.label', {type: $t(object_name)}) }}
            <input :name="`${object_name}[request_approval]`" type="hidden" :value="false" />
            <input id="request_approval" :name="`${object_name}[request_approval]`" :checked="true" @change="separateStates" v-model="parsedObject.request_approval" type="checkbox">
          </label>
        </div>
        <div v-if="allow_default == 'true'" class="form-group select-group">
          <label for="default">{{ $t('default_status.label', {type: $t(object_name)}) }}
            <input :name="`${object_name}[default]`" type="hidden" :value="false" />
            <input id="default" :name="`${object_name}[default]`" v-model="parsedObject.default" :checked="true" type="checkbox">
          </label>
        </div>
      </div>
      <div v-else>
        <div class="form-group select-group fr">
          <label for="active">{{ $t('means_active.label', {type: $t(object_name)}) }}
            <input id="active" :name="`${object_name}[active]`" v-model="parsedObject.active" type="checkbox" :value=parsedObject.active>
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>
<script>
  export default {
    props: ['locale', 'object_name', 'approval', 'object', 'object_errors', 'allow_default'],
    data() {
      return {
        parsedObject: {
          name: {
            en: '',
            fr: ''
          },
          active: false,
          approved: false,
          request_approval: false,
          default: false
        },
        errors: {}
      }
    },
    mounted() {
      try {
        this.parsedObject = JSON.parse(this.object) || {}
        this.errors = JSON.parse(this.object_errors) || {}
      }
      catch {
        console.log("There was an error loading the object")
      }
    },
    methods: {

      // Sets the name inputs to the correct value
      getName(lang) {
        return this.parsedObject.name && this.parsedObject.name[lang] ? this.parsedObject.name[lang] : ''
      },

      // Generates the appropriate classes for a form input based on the field name
      formClasses(field) {
        return this.errors && this.errors[field] ? 'form-control error-input' : 'form-control'
      },

      // Triggered on the approved or request_approval checkboxes being chnaged
      // Ensures that the "approved" and "request approval" states remain separated since a status can't have both checked
      separateStates(event) {
        if(event.target.id === "request_approval" && event.target.checked) {
          var approvedBox = document.getElementById("approved")
          if(approvedBox.checked) {
            approvedBox.checked = false;
          }
        }
        else if(event.target.id === "approved" && event.target.checked) {
          var requestApprovalBox = document.getElementById("request_approval")
          if(requestApprovalBox.checked) {
            requestApprovalBox.checked = false;
          }
        }
      }
    }
  }
</script>  
